import CrudAPI from '@/api/resources/crud'
import store from '@/store'

const plansAPI = {
  // specific plans api
  url_query: '/api/plans',

  getLinkedInventories (itemId) {
    let url = store.getters.config.api_host + this.url_query + '/' + itemId + '/inventories'

    return new Promise((resolve, reject) => {
      store.getters.axios.get(url).then(response => {
        resolve(response.data.additional_data)
      }, error => {
        reject(error)
      })
    })
  },

  getLinkedServices (itemId) {
    let url = store.getters.config.api_host + this.url_query + '/' + itemId + '/services'

    return new Promise((resolve, reject) => {
      store.getters.axios.get(url).then(response => {
        resolve(response.data.additional_data)
      }, error => {
        reject(error)
      })
    })
  },

  loadPlans () {
    return new Promise((resolve, reject) => {
      let plans = CrudAPI.dfsResourceIndex('plans')

      plans.then(result => {
        result.forEach((item, i) => {
          item.text = item.name
          item.value = item.id
        })

        resolve(result)
      }, error => {
        reject(error)
      })
    })
  },

  loadPlan (id) {
    return new Promise((resolve, reject) => {
      let plans = CrudAPI.dfsResourceShow('plans', id)

      plans.then(result => {
        resolve(result)
      }, error => {
        reject(error)
      })
    })
  }
}

export default plansAPI



// WEBPACK FOOTER //
// ./src/api/resources/plans.js